/* eslint-disable */
// This is the javascript entrypoint for the image-element snippet.
// This file and all its inclusions will be processed through esbuild

import '@archetype-themes/scripts/config';
import '@archetype-themes/scripts/helpers/sections';

/*  ============================================================================
  ImageElement
==============================================================================  */

class ImageElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.markAsLoaded();
  }

  markAsLoaded() {
    // Find the closest image-wrap and mark it as loaded
    const imageWrap = this.closest('.image-wrap');
    const skrimWrap = this.closest('.skrim__link');

    if (imageWrap) {
      imageWrap.classList.add('loaded');
    }

    if (skrimWrap) {
      skrimWrap.classList.add('loaded');
    }
  }
}

customElements.define('image-element', ImageElement);
